import Vue from 'vue'

import AvatarList from '@/components/AvatarList/index'
// chart
import Bar from '@/components/chart/Bar'
import ChartCard from '@/components/chart/ChartCard'
import Liquid from '@/components/chart/Liquid'
import MiniArea from '@/components/chart/MiniArea'
import MiniBar from '@/components/chart/MiniBar'
import MiniProgress from '@/components/chart/MiniProgress'
import Radar from '@/components/chart/Radar'
import RankList from '@/components/chart/RankList'
import TransferBar from '@/components/chart/TransferBar'
// ------我是分割线----------
import CountDown from '@/components/CountDown/index'
import Ellipsis from '@/components/Ellipsis/index'
import FooterToolbar from '@/components/FooterToolbar/index'
import NumberInfo from '@/components/NumberInfo/index'
import Tree from '@/components/Tree/Tree'
import Trend from '@/components/Trend/index'

import STable from '@/components/table'
import RSearch from '@/components/search'
import RPointer from '@/components/pointer'
import ReportSearch from '@/components/ReportSearch'
// 表格内 单元格编辑
import EditableCell from '@/components/EditableCell'
// 视图相关 -- 点击详情查看的视图
import ContentView from '@/components/ContentView'
import { BHeaderSecondary } from '@comp/BHeader/index'
// svg图标
import BSvgIcon from '@/components/BSvgIcon'

const components = {
  ReportSearch,
  AvatarList,
  Bar,
  ChartCard,
  Liquid,
  MiniArea,
  MiniBar,
  MiniProgress,
  Radar,
  RankList,
  TransferBar,
  Trend,
  CountDown,
  Ellipsis,
  FooterToolbar,
  NumberInfo,
  Tree,
  STable,
  RSearch,
  RPointer,
  EditableCell,
  ContentView,
  BHeaderSecondary,
  BSvgIcon
}

Vue.use({
  install: Vue => {
    Object.keys(components).forEach(key => {
      Vue.component(`${key}`, components[key])
    })
  }
})
